module.exports = __webpack_public_path__ + "a34382ed96b4d15e253b74308bb5e4f4.MP3";